import { createClient } from "@sanity/client";

const isTestRuntime =
  process.env.NODE_ENV === "test" || process.env.VITEST === "true" || process.env.VITEST === "1";

export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID ?? (isTestRuntime ? "sanity-test-project" : undefined);
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION ?? "2024-02-08";
export const dataset =
  process.env.NEXT_PUBLIC_SANITY_DATASET ?? process.env.SANITY_DATASET_PUBLIC ?? process.env.SANITY_DATASET ?? "public";

if (!projectId) {
  throw new Error("Missing NEXT_PUBLIC_SANITY_PROJECT_ID for browser Sanity client.");
}

export const sanityBrowserClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: true,
});
